const apiUrl = '/components/asset-acquisition/api';

export default apiUrl;
